<template>
  <div>
    <delete-group-popup
      :group="currentGroup"
      @delete="fetchGroups"
    />
    <b-card>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="loadingGroups"
      >
        <b-row class="mb-1">
          <b-col md="4">
            <label
              for="target"
              class="mr-1"
            >Search by target</label>
            <v-select
              id="target"
              v-model="currTarget"
              :clearable="false"
              :options="targetOptions"
              :reduce="(val) => val.key"
              @input="search"
            />
          </b-col>
          <b-col md="4">
            <b-form-group label="Name">
              <b-form-input
                v-model="queryParams.name"
                palceholder="Search by name"
              />
            </b-form-group>
          </b-col>
          <b-col
            class="d-flex justify-content-center align-items-center"
            md="4"
          >
            <b-button
              variant="primary"
              class="mr-1"
              @click="fetchGroups"
            >
              Search
            </b-button>
            <b-button
              v-if="$can('write', 'groups')"
              variant="success"
              @click="$router.push('/create-group')"
            >
              Create Group
            </b-button>
            <b-button
              class="btn-icon rounded-circle"
              variant="flat-primary"
              @click="fetchGroups"
            >
              <feather-icon icon="RefreshCwIcon" />
            </b-button>
          </b-col>
        </b-row>
        <b-table
          fixed
          :fields="tableColumns"
          :items="groups"
          class="mb-2 text-center"
          sort-by="createdAt"
          sort-desc
          show-empty
          empty-text="No matching records found"
        >
          <template #cell(name)="data">
            <div v-html="textFormatter(data.item.name)" />
          </template>
          <template #cell(description)="data">
            <div
              v-html="textFormatter(data.item.description)"
            />
          </template>
          <template #cell(target)="data">
            <b-badge
              pill
              :variant="`light-${data.item.target === 'drivers' ? 'success' : 'primary'}`"
              class="text-capitalize"
            >
              {{ data.item.target }}
            </b-badge>
          </template>
          <template #cell(actions)="data">
            <b-button
              v-if="!data.item.locked"
              class="btn-icon rounded-circle"
              variant="flat-danger"
              @click="openDeleteModal(data.item)"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
            <b-button
              v-if="$can('write', 'groups')"
              class="btn-icon rounded-circle"
              variant="flat-primary"
              :to="{name: 'create-group', query: {view: true, id: data.item.id}}"
            >
              <feather-icon icon="EyeIcon" />
            </b-button>
            <b-button
              v-if="$can('write', 'groups')"
              class="btn-icon rounded-circle"
              variant="flat-warning"
              :to="{name: 'edit-group', params: {id: data.item.id}}"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
          </template>
        </b-table>
        <base-pagination
          v-model="queryParams.page"
          :total="total"
          @new-per-page="queryParams.perPage = $event"
        />
      </b-overlay>
    </b-card>
  </div>
</template>

<script>

import {
  BButton, BTable, BCard, BOverlay, BBadge, BFormGroup, BFormInput, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import BasePagination from '@/UI/BasePagination.vue'
import useGroups from '../hooks/useGroups'
import groupsStore from '../store'
import DeleteGroupPopup from '../components/DeleteGroupPopup.vue'

export default {
  components: {
    BButton,
    BTable,
    BCard,
    BasePagination,
    BOverlay,
    vSelect,
    DeleteGroupPopup,
    BBadge,
    BFormGroup,

    BRow,
    BCol,
    BFormInput,
  },
  setup(_, ctx) {
    useRegisterStoreModule('groups', groupsStore)

    return {
      ...useGroups(ctx),

    }
  },
}
</script>
